// Helpers to group / filter admin lists per month ("2026-11" -> "november 2026").
export const toDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const monthKeyOf = (value) => {
  const d = toDate(value);
  if (!d) return "none";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthLabel = (key) => {
  if (!key || key === "none") return "Zonder datum";
  const [y, m] = key.split("-").map(Number);
  const label = new Date(y, m - 1, 1).toLocaleDateString("nl-NL", { month: "long", year: "numeric" });
  return label.charAt(0).toUpperCase() + label.slice(1);
};

// [{ key, label, count }] newest first, "Zonder datum" last.
export const monthOptions = (items, getDate) => {
  const counts = new Map();
  items.forEach((item) => {
    const key = monthKeyOf(getDate(item));
    counts.set(key, (counts.get(key) || 0) + 1);
  });
  return [...counts.entries()]
    .sort(([a], [b]) => (a === "none" ? 1 : b === "none" ? -1 : b.localeCompare(a)))
    .map(([key, count]) => ({ key, label: monthLabel(key), count }));
};

// Sort newest first by the chosen date (items without a date at the end).
export const sortByDateDesc = (items, getDate) =>
  [...items].sort((a, b) => {
    const da = toDate(getDate(a));
    const db = toDate(getDate(b));
    if (!da && !db) return 0;
    if (!da) return 1;
    if (!db) return -1;
    return db - da;
  });
